'use client';

import { c as _c } from "react/compiler-runtime";
import { Modal } from '@7f-ui/components/modal/modal';
import { useToast } from '@7f-ui/components/toast/toast-provider';
import type { CartItemExperienceFragment } from '@data-access/lib/gql/cart/documents';
import { useCartItem } from '@feat/feat-cart/item';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { parseLocalDate } from '@utils/helpers';
import { AppDateModalContent } from '../../erlebnisse/_components/app-date-modal';
import { AppEdpBookingFlow } from '../../erlebnisse/_components/app-edp-booking-flow';
import { ExperienceFilterProvider, useExperienceFilterContext } from '../../erlebnisse/_components/app-experience-filter-provider';
import { AppPersonModalContent } from '../../erlebnisse/_components/app-person-modal';
import { useAppExperienceAvailableDates } from '../../erlebnisse/_hooks/use-app-experience-available-dates';
import { useExperienceOptions } from '../../erlebnisse/_hooks/use-app-experience-options';
import { FilterType } from '../../erlebnisse/_lib/experience-booking-utils';
import { AppCartItemTicketModal } from './app-cart-item-ticket-modal';
import { AppExperienceListModalContent } from './app-experience-list-modal-content';
enum ModalType {
  Person = FilterType.person,
  Date = FilterType.date,
  List = 'List',
  Booking = 'Booking',
}
type AppCartItemExperienceModalProps = {
  item: CartItemExperienceFragment | null;
  onClose: VoidFunction;
};
export function AppCartItemExperienceModal(t0) {
  const $ = _c(21);
  const {
    item,
    onClose
  } = t0;
  const edpBookingFlow = useFeatureValue("edp-booking-flow", "control");
  const isVariantB = edpBookingFlow === "variant-b";
  let t1;
  if ($[0] !== item?.experience) {
    t1 = item?.experience ?? {};
    $[0] = item?.experience;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    variants: t2
  } = t1;
  let t3;
  if ($[2] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const variants = t3;
  const {
    getSelectedOptions
  } = useExperienceOptions(variants);
  const selectedVariant = item?.variantId;
  let t4;
  if ($[4] !== item?.tickets) {
    t4 = item?.tickets ?? [];
    $[4] = item?.tickets;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== getSelectedOptions || $[7] !== t4) {
    t5 = getSelectedOptions(t4);
    $[6] = getSelectedOptions;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const selectedOptions = t5;
  if (item && !item.timeslot) {
    let t6;
    if ($[9] !== item || $[10] !== onClose) {
      t6 = <AppCartItemTicketModal item={item} onClose={onClose} />;
      $[9] = item;
      $[10] = onClose;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    return t6;
  }
  const t6 = !!item;
  let t7;
  if ($[12] !== isVariantB || $[13] !== item || $[14] !== selectedOptions || $[15] !== selectedVariant) {
    t7 = t8 => {
      const {
        onClose: closeModal,
        setActiveContent,
        activeContent
      } = t8;
      if (!item) {
        return null;
      }
      if (!item.timeslot) {
        return null;
      }
      const initialFilter = {
        from: parseLocalDate(item.timeslot.startDate),
        to: parseLocalDate(item.timeslot.endDate),
        selectedOptions,
        selectedVariant
      };
      const slides = isVariantB ? [{
        name: ModalType.Person,
        title: "Personen w\xE4hlen",
        children: <AppPersonModalContent onSubmit={() => {
          setActiveContent(ModalType.Booking);
        }} showContactFormLink={false} />
      }, {
        name: ModalType.Booking,
        title: "Datum w\xE4hlen",
        onBackClick: () => setActiveContent(ModalType.Person),
        children: <BookingContent item={item} onClose={closeModal} />
      }] : [{
        name: ModalType.Person,
        title: "Personen w\xE4hlen",
        children: <AppPersonModalContent onSubmit={() => {
          setActiveContent(ModalType.Date);
        }} showContactFormLink={false} />
      }, {
        name: ModalType.Date,
        title: "Datum w\xE4hlen",
        onBackClick: () => setActiveContent(ModalType.Person),
        children: <DateContent onClose={() => setActiveContent(ModalType.List)} />
      }, {
        name: ModalType.List,
        title: "Termin w\xE4hlen",
        onBackClick: () => setActiveContent(ModalType.Date),
        children: <AppExperienceListModalContent item={item} onClose={closeModal} />
      }];
      return <ExperienceFilterProvider experience={item.experience} initialFilter={initialFilter}><Modal.Slides activeContent={activeContent} onClose={closeModal} slides={slides} /></ExperienceFilterProvider>;
    };
    $[12] = isVariantB;
    $[13] = item;
    $[14] = selectedOptions;
    $[15] = selectedVariant;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== onClose || $[18] !== t6 || $[19] !== t7) {
    t8 = <Modal isOpen={t6} onClose={onClose} initialContent={ModalType.Person}>{t7}</Modal>;
    $[17] = onClose;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
function DateContent(t0) {
  const $ = _c(3);
  const {
    onClose
  } = t0;
  const {
    experience,
    filter
  } = useExperienceFilterContext();
  const {
    availableDates
  } = useAppExperienceAvailableDates(experience.publicId, filter.selectedVariant, filter.selectedOptions);
  let t1;
  if ($[0] !== availableDates || $[1] !== onClose) {
    t1 = <AppDateModalContent onClose={onClose} availableDates={availableDates} />;
    $[0] = availableDates;
    $[1] = onClose;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function BookingContent(t0) {
  const $ = _c(15);
  const {
    item,
    onClose
  } = t0;
  const toast = useToast();
  const {
    experience,
    filter
  } = useExperienceFilterContext();
  const {
    updateExperience
  } = useCartItem();
  const {
    availableDates,
    isPreliminary
  } = useAppExperienceAvailableDates(experience.publicId, filter.selectedVariant, filter.selectedOptions);
  let t1;
  if ($[0] !== item.timeslot) {
    t1 = item.timeslot ? parseLocalDate(item.timeslot.startDate) : null;
    $[0] = item.timeslot;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const initialDate = t1;
  let t2;
  if ($[2] !== filter.selectedOptions || $[3] !== item.experience || $[4] !== item.id || $[5] !== onClose || $[6] !== toast || $[7] !== updateExperience) {
    t2 = (timeslot, t3) => {
      const {
        onSuccess,
        onError
      } = t3;
      if (!filter.selectedOptions) {
        onError();
        return;
      }
      updateExperience(item.id, {
        timeslotId: timeslot.id,
        experienceId: item.experience.id,
        selectedOptions: filter.selectedOptions
      }, {
        onSuccess: () => {
          toast({
            type: "success",
            message: "Deine Auswahl wurde angepasst"
          });
          onSuccess();
          onClose();
        }
      });
    };
    $[2] = filter.selectedOptions;
    $[3] = item.experience;
    $[4] = item.id;
    $[5] = onClose;
    $[6] = toast;
    $[7] = updateExperience;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleSubmit = t2;
  const t3 = item.timeslot?.id;
  let t4;
  if ($[9] !== availableDates || $[10] !== handleSubmit || $[11] !== initialDate || $[12] !== isPreliminary || $[13] !== t3) {
    t4 = <AppEdpBookingFlow availableDates={availableDates} availableDatesArePreliminary={isPreliminary} initialDate={initialDate} initialTimeslotId={t3} submitLabel={"\xDCbernehmen"} mode="update" onSubmit={handleSubmit} />;
    $[9] = availableDates;
    $[10] = handleSubmit;
    $[11] = initialDate;
    $[12] = isPreliminary;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}